import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { useIsWebView } from '@/hooks/useSizeBreakpoints'
import { useIsINSEnabled } from '@/shared/model/useIsINSEnabled'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { isStaff } from '@/utils/type-guards'
import { compact } from 'lodash'

export function useConfigurationTabs() {
  const lingui = useLingui()

  const authUser = useAppSelector(selectAuthUser)
  const isDoctor = isStaff(authUser) && authUser.status === 'MEDECIN'

  const isWebView = useIsWebView()
  const { hasLicense: hasINSLicense, isINSEnabled } = useIsINSEnabled()

  return useMemo(
    () =>
      compact([
        { label: lingui._(t`Personal informations`), value: 'profile' as const },
        { label: lingui._(t`Appearance`), value: 'appearance' as const },
        isDoctor && { label: lingui._(t`Report type`), value: 'conclusion-sentences' as const },
        { label: lingui._(t`Device setting`), value: 'custom-devices' as const },
        !isWebView && { label: lingui._(t`Local devices settings`), value: 'medconnect-devices' as const },
        hasINSLicense && { label: lingui._(t`Patient management`), value: 'patient-management' as const },
        isINSEnabled && { label: lingui._(t`DMP Connect`), value: 'dmp-connect' as const },
        { label: lingui._(t`Payment`), value: 'payment' as const },
        { label: lingui._(t`My availabilities`), value: 'select-time-slot' as const },
        { label: lingui._(t`Chat settings`), value: 'display-chat-form' as const },
        { label: lingui._(t`Your calcom credentials`), value: 'calendso-password' as const },
        { label: lingui._(t`Unit system`), value: 'unit-system' as const },
        { label: lingui._(t`Time tracking`), value: 'time-tracking' as const },
        { label: lingui._(t`Automatic offline mode`), value: 'autoSwitchOffline' as const },
      ]),
    [isDoctor, isWebView, hasINSLicense, isINSEnabled, lingui]
  )
}

export type TabValue = ReturnType<typeof useConfigurationTabs>[number]['value']
